module.exports = {"title":"Events","subTitle":"Select Events for which the Coupon can be redeemed.","updateBtn":"Update","noEvents":"There are no events to display.","eventsTable":{"event":"Event","dateAndTime":"Date & time"},"saveBtn":"Save Coupon","createBtn":"Create Coupon"}


//////////////////
// WEBPACK FOOTER
// ./src/components/CreateCoupon/CouponEvents/locales/en.json
// module id = 1708
// module chunks = 0